import PropTypes from 'prop-types'
import { timeSliceGenerateResponsePropType } from './time-slice-generate-response-prop-type'

/**
 * @typedef {Object} DriverKpi
 * @property {number} [driverId]
 * @property {Object} [kpis]       - Not further specified by Swagger REST.
 * @property {Object} [timeSlice]
 */

export const driverKpiPropType = PropTypes.shape({
    driverId: PropTypes.number,
    kpis: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    timeSlice: timeSliceGenerateResponsePropType
})
